import { useCallback } from "react";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import { ScanResult } from "@coworker/apprestructured/src/scan-and-search/hooks/useDetectBarcode";
import { mapBarcodeFormatToSymbologyType } from "@coworker/apprestructured/src/scan-and-search/pages/camera-scanner-page/cameraScannerPageUtils";
import { extractBasedOnSymbology } from "@coworker/apprestructured/src/scan-and-search/helpers/extractBasedOnSymbologyUtils";
import { cameraFailedToReadBarcodeError } from "@coworker/apprestructured/src/scan-and-search/helpers/scannerSentryErrorHandlerUtils";
import { CameraScannerComponent } from "@coworker/apprestructured/src/scan-and-search/pages/camera-scanner-page/CameraScannerComponent";

export const Camera = ({
  handleScannedArticle,
}: {
  handleScannedArticle: (articleId?: string) => void;
}) => {
  const onDetected = useCallback(
    (scanResult: ScanResult) => {
      const symbology = mapBarcodeFormatToSymbologyType(scanResult.format);
      let articleInformation;
      try {
        articleInformation = extractBasedOnSymbology(
          symbology,
          scanResult.barcode
        );
      } catch (error: unknown) {
        cameraFailedToReadBarcodeError(error);
      }
      handleScannedArticle(articleInformation?.articleNumber);
    },
    [handleScannedArticle]
  );

  return (
    <CameraScannerComponent
      onDetected={onDetected}
      presentationProps={{
        taskType: TaskType.NO_TASK_TYPE,
        pushSearch: () => handleScannedArticle(),
      }}
    />
  );
};
